export default "__VITE_ASSET__8faf6753__"